import { api } from './api.service';

export interface IFileRequest {
  key: string;
}

export interface IFileResponse {
  url: string;
}

export const FileService = api.injectEndpoints({
  endpoints: build => ({
    getFileUrl: build.mutation<IFileResponse, IFileRequest>({
      query: ({ key }) => ({
        url: `/oyanafiles`,
        method: 'PUT',
        body: { key }
      })
    }),

    getObjectUrl: build.mutation<{ url: string }, { url: string }>({
      query: ({ url }) => ({
        url: `/oyanafiles/generateUrlSignature`,
        method: 'PUT',
        body: { url }
      })
    }),

    getFileDownloadUrl: build.mutation<Blob, { id: string; force?: boolean }>({
      query: ({ id, force }) => ({
        url: `/portal/v1/me/${id}/download`,
        method: 'GET',
        params: { ...(force ? { force: true } : {}) },
        responseHandler: response => response.blob()
      })
    }),

    getFileDownloadUrlSigned: build.mutation<IFileResponse, { id: string }>({
      query: ({ id }) => ({
        url: `/portal/v1/me/${id}/download`,
        method: 'GET'
      })
    }),

    logSelectedFile: build.mutation<void, string>({
      query: fileId => ({
        url: `/oyanafiles/${fileId}/log`,
        method: 'PUT'
      })
    })
  })
});

export const {
  useGetFileUrlMutation,
  useGetObjectUrlMutation,
  useGetFileDownloadUrlMutation,
  useGetFileDownloadUrlSignedMutation,
  useLogSelectedFileMutation
} = FileService;
